// http://sd-redmine.ign.fr/issues/12252 : Contiendra au début les utilitaires globaux et progressivement des classes utilitaires

class GpuSite {

    static addSort(field, descAtFirstSort, sortFieldSelector) {
        var selector = sortFieldSelector || '#search_sort';
        var hiddenFieldSort = $(selector);
        var form = hiddenFieldSort.parents('form:first');

        var currentSort = hiddenFieldSort.val();
        var parts = currentSort.split(':');
        var currentSortBy = parts[0];
        var currentSortOrder = parts[1];

        var newSortOrder = descAtFirstSort ? 'desc' : 'asc';

        if (currentSortBy === field) {
            if (currentSortOrder === 'asc') {
                newSortOrder = 'desc';
            } else {
                newSortOrder = 'asc';
            }
        }

        var newSort = field + ':' + newSortOrder;
        hiddenFieldSort.val(newSort);
        form.trigger('submit');
    }

    static addDatepicker() {
        var ladate = new Date();
        var anneeCourante = ladate.getFullYear();

        $('.datepicker').datepicker({
            dateFormat: 'dd/mm/yy',
            showButtonPanel: true,
            changeMonth: false,
            changeYear: true,
            showOtherMonths: true,
            selectOtherMonths: false,
            yearRange: '1990:' + anneeCourante
        });

        $('.datepicker-futur').datepicker({
            dateFormat: 'dd/mm/yy',
            showButtonPanel: true,
            changeMonth: false,
            changeYear: true,
            showOtherMonths: true,
            selectOtherMonths: false,
            yearRange: anneeCourante + ':2100'
        });
    }

    static addPopup() {

        // ouvrir la popup quand :
        // - elle n'a jamais été ouverte
        // - la date de modification de l'article contenu dans la popup a été modifié

        // si l'admin n'a pas activé la popup
        if (!IS_POPUP_ACTIVATED) {
            return;
        }

        // si pas de date récupéré on n'ouvre pas la popup
        if ('no date' === LAST_UPDATED_AT_POPUP_ARTICLE) {
            return;
        }

        // - on n'ouvre pas la popup si on est sur la page d'édition d'article (la date de l'article se met à jour dans la page d'édition
        //   ce qui ouvre la popup alors qu'on n'a pas modifié encore l'article)
        if ('gpu_admin_article_edit' === ACTUAL_ROUTE) {
            return;
        }

        // la popup est active, on affiche le lien vers le contenu de la popup dans le footer
        $('#popup-content').removeClass('hidden');
        $('#popup-content a').on('click', function (event) {
            event.preventDefault();
            $('#popup-modal').modal('show');
        });

        // on se base sur le cache local du navigateur en  gardant la date de derniere modification de l'article
        // si il n'existe pas : on ouvre la poupup
        // si il existe mais la date est différente : on ouvre la popup
        // puis on enregistre la nouvelle date

        // 1) récupérer la date de modification de l'article
        var newDate = LAST_UPDATED_AT_POPUP_ARTICLE;
        var oldDate = window.localStorage.getItem('gpu-popup-date');


        // 2a) si la date n'existe pas, on ouvre la popup
        if (null === oldDate) {
            $('#popup-modal').modal('show');
            window.localStorage.setItem('gpu-popup-date', newDate);

            // 2b) si la date existante est différente de celle contenu dans le cache, on ouvre la popup
        } else if (oldDate !== newDate) {
            $('#popup-modal').modal('show');
            window.localStorage.setItem('gpu-popup-date', newDate);
        }
    }

    static addTooltip() {
        $('.gpu-tooltip').tooltip();
    }

    static init() {
        /* datepicker */
        GpuSite.addDatepicker();

        /* initialisation des tooltip */
        GpuSite.addTooltip();

        /* Activation de la popup géré par les administrateurs */
        GpuSite.addPopup();
    }
}

window.addSort = function (field, descAtFirstSort, sortFieldSelector) {
    return GpuSite.addSort(field, descAtFirstSort, sortFieldSelector);
};

$(function () {
    GpuSite.init();
});
